import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { CommonModule } from '@angular/common';

interface ImageFieldProps {
  id?: string;
  type?: string;
  runTime?: string;
  border?: boolean;
  labelPosition?: 'Top' | 'Left' | 'Right' | 'Bottom';
  label?: string;
  caption?: string;
  infoCaption?: string;
  infoBody?: string;
  URL?: string;
  visible?: boolean;
  enable?: boolean;
  errorText?: string;
}

@Component({
  selector: 'formly-image-field',
  imports: [CommonModule],
  template: `
    <div class="image-field" [ngClass]="{ border: props.border, 'error-border': props.enable }">
      @switch (props.labelPosition || 'Top') {
        @case ('Top') {
          <div class="label-top">
            <label>{{ props.label || props.caption }}</label>
            <img class="img-fluid" [src]="props.URL" (error)="handleImageError($event)" alt="Image" />
          </div>
        }
        @case ('Left') {
          <div class="label-left">
            <label>{{ props.label || props.caption }}</label>
            <img class="img-fluid" [src]="props.URL" (error)="handleImageError($event)" alt="Image" />
          </div>
        }
        @case ('Right') {
          <div class="label-right">
            <img class="img-fluid" [src]="props.URL" (error)="handleImageError($event)" alt="Image" />
            <label>{{ props.label || props.caption }}</label>
          </div>
        }
        @case ('Bottom') {
          <div class="label-bottom">
            <img class="img-fluid" [src]="props.URL" (error)="handleImageError($event)" alt="Image" />
            <label>{{ props.label || props.caption }}</label>
          </div>
        }
      }

      @if (props.infoCaption || props.infoBody) {
        <div class="info-caption">
          <span class="blue-dot" [title]="props.infoCaption" [innerHTML]="props.infoBody"></span>
        </div>
      }

      @if (props.errorText) {
        <div class="error-text" [title]="props.errorText">
          {{ props.errorText }}
        </div>
      }
    </div>
  `,
  styles: [
    `
      .image-field {
        position: relative;
        padding-top: 0.625rem;
      }
      .img-fluid {
        max-width: 100%;
        height: auto;
      }
      .border {
        border: 1px solid #white;
      }
      .error-border {
        border: 2px solid red;
      }
      .label-top {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .label-left {
        display: flex;
        align-items: center;
      }
      .label-right {
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
      }
      .label-bottom {
        display: flex;
        flex-direction: column;
        align-items: left;
      }
      label {
        font-size: 1rem;
        margin-top: 1.25rem;
      }
      .info-caption {
        margin-top: 0.3125rem;
      }
      .blue-dot {
        display: inline-block;
        width: 0.625rem;
        height: 0.625rem;
        background: blue;
        border-radius: 50%;
        cursor: help;
      }
      .error-text {
        color: red;
        font-size: 0.75rem;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageFieldComponent extends FieldType<FieldTypeConfig<ImageFieldProps>> {
  ngOnInit() {
    this.props.URL = './assets/product-icons/ScrewHeatPumpRedAstrum.jpg'; //temporary fix unlit we get link from backend
  }
  handleImageError(event: Event) {
    console.error('Image failed to load:', this.props.URL);
  }
}
